import React from 'react';
//import ProductList from './ProductList';
import BtnAll from '../images/btn_seeall.png';
import ImageList from './ImageList';
import { Link } from 'react-router-dom';


function Seall() {

    return (
        <div class="max-w-full px-4 py-10 sm:px-6 lg:px-0 lg:py-0 mx-auto bg-[#fefaed]">
            <div class="max-w-7xl mx-auto">
                <section class="py-1 text-center"><br />
                    <button class="mt-1 px-6 py-2"><Link to="/allproduct"><img src={BtnAll} alt="" style={{ width: 300 }}/></Link></button>
                </section>
                <br /><br /><br />
                <section class="py-10 text-center">
                    <h3 class="font-bold text-2xl mb-6 sm:text-base md:text-lg lg:text-xl" style={{ color: '#fb8319', fontFamily: 'MuseoSansRounded700', fontSize: 38 }}>SHOP BY CATEGORY</h3>
                    <div class="max-w-full px-4 py-0 sm:px-6 lg:px-0 lg:py-0 mx-auto">
                        <Link to="/allproduct">
                            <ImageList />
                        </Link>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Seall;
